
import Lang from 'lang.js';

export default class TranslationHelper extends Lang {
    constructor(options) {
        super(options);
        this.messages = options.messages;
    }

    _parseKey(key) {
        if (typeof key !== 'string') {
            return null;
        }

        const segments = key.split('.');
        const source = segments[0].replace(/\//g, '.');

        return {
            source,
            sourceFallback: source,
            entries: segments.slice(1)
        };
    }

    getAndReplace(key, replacements) {
        if (typeof key !== 'string') {
            return null;
        }
        if (typeof replacements !== 'object') {
            return null;
        }
        return this.choice(key, 1, replacements);
    }
}



// WEBPACK FOOTER //
// ./src/helpers/TranslationHelper/TranslationHelper.js